module.exports = __webpack_public_path__ + "static/media/22770514_1629548807120304_5297564292559943317_o.f721cad6.jpg";